export const ALL_COLUMNS = 'All columns';
export const selectOptions = [
  { value: 'listenAddress', label: 'Listen address' },
  { value: 'parameter', label: 'Parameter' },
  { value: 'description', label: 'Description' }
];

export const PROJECT_PAGE = 'project';
export const PROJECT_MOCK_DATA = {
  id: -1,
  dataType: '',
  masterListDataId: -1,
  projectTabId: -1,
  parameter: ''
};
export interface ColumnSetting {
  Header: string,
  accessor: string,
  hidden: boolean,
  metaCol?: string,
  sticky: string | null,
  minWidth: number,
  forMemberOrAdmin?: boolean,
}
export const getColumnSettings = (): ColumnSetting[] => [
  {
    Header: 'Data Type',
    accessor: 'dataType',
    hidden: false,
    metaCol: 'DATA_TYPE',
    sticky: null,
    minWidth: 140
  },
  {
    Header: 'Listen Address',
    accessor: 'listenAddress',
    hidden: false,
    metaCol: 'LISTEN_ADDRESS',
    sticky: null,
    minWidth: 140
  },
  {
    Header: 'Factor',
    accessor: 'factor',
    hidden: false,
    metaCol: 'FACTOR',
    sticky: null,
    minWidth: 140
  },
  {
    Header: 'Bit',
    accessor: 'bit',
    hidden: false,
    metaCol: 'BIT',
    sticky: null,
    minWidth: 140
  },
  {
    Header: 'Min',
    accessor: 'min',
    hidden: false,
    metaCol: 'MIN',
    sticky: null,
    minWidth: 140
  },
  {
    Header: 'Max',
    accessor: 'max',
    hidden: false,
    metaCol: 'MAX',
    sticky: null,
    minWidth: 140
  },
  {
    Header: 'Type',
    accessor: 'type',
    hidden: false,
    metaCol: 'TYPE',
    sticky: null,
    minWidth: 140
  },
  {
    Header: 'Parameter',
    accessor: 'parameter',
    hidden: false,
    metaCol: 'PARAMETER',
    sticky: null,
    minWidth: 140
  },
  {
    Header: 'Units',
    accessor: 'units',
    hidden: false,
    metaCol: 'UNITS',
    sticky: null,
    minWidth: 140
  },
  {
    Header: 'Responsible',
    accessor: 'responsible',
    hidden: false,
    metaCol: 'RESPONSIBLE',
    sticky: null,
    minWidth: 140
  },
  {
    Header: 'Description',
    accessor: 'description',
    hidden: false,
    metaCol: 'DESCRIPTION',
    sticky: null,
    minWidth: 140
  },
  {
    Header: 'Sa Description',
    accessor: 'saDescription',
    hidden: false,
    metaCol: 'SA_DESCRIPTION',
    sticky: null,
    minWidth: 140
  },
  {
    Header: 'Tt Description',
    accessor: 'ttDescription',
    hidden: false,
    metaCol: 'TT_DESCRIPTION',
    sticky: null,
    minWidth: 140
  },
  {
    Header: 'Comment',
    accessor: 'comment',
    hidden: false,
    metaCol: 'COMMENT',
    sticky: null,
    minWidth: 140
  },
  {
    Header: 'Action',
    hidden: false,
    accessor: 'action',
    sticky: 'right',
    minWidth: 140,
    forMemberOrAdmin: true
  }
];
